import { updateMerkzettelStateInMenu } from "@modules/bookmarks/bookmarks-menu-item.ts"
import { queryElement } from "@modules/bookmarks/html-elements.ts"
import { showEmptyTagHitsContainer } from "@modules/bookmarks/tags/Tag.ts"
import { InfoPanel } from "@modules/info-panel/InfoPanel.ts"
import QRCode from "easyqrcodejs"

interface ShareKeyResponse {
    shareKey: string
}
export async function addEventListenersForSideBarOptions() {
    const deleteAllButtonElement = document.getElementById("bookmarks-delete-elements") as HTMLButtonElement | null
    const cleanOfflineBookmarksButtonElement = document.getElementById(
        "bookmarks-remove-unavailable",
    ) as HTMLButtonElement | null
    const shareAllButtonElement = document.getElementById("bookmarks-share") as HTMLButtonElement | null
    const collapseExpandButtonElement = document.getElementById("toggle-bookmarks-collapse") as HTMLButtonElement | null
    const shareModal = document.getElementById("merkzettel-modal-share-all") as HTMLDivElement | null
    const confirmEntriesDeletionModal = document.getElementById("delete-elements-modal") as HTMLDivElement | null

    if (deleteAllButtonElement) {
        deleteAllButtonElement.addEventListener("click", async () => {
            if (confirmEntriesDeletionModal) {
                const confirmEntriesDeletionModalConfirmButton = queryElement(
                    ".confirm-delete-elements",
                    confirmEntriesDeletionModal,
                ) as HTMLButtonElement | null
                const tagSlug = document.querySelector(".tag.tag-selected")?.getAttribute("data-tag-slug") ?? ""

                if (tagSlug !== "") {
                    const confirmEntriesDeletionModalTitle = confirmEntriesDeletionModal.querySelector(
                        ".modal-title",
                    ) as HTMLHeadingElement | null
                    const confirmEntriesDeletionModalBody = confirmEntriesDeletionModal.querySelector(
                        ".modal-body",
                    ) as HTMLDivElement | null

                    if (confirmEntriesDeletionModalBody) {
                        confirmEntriesDeletionModalBody.innerHTML =
                            "Du bist dabei, alle Einträge zu entfernen, denen du das Tag <strong>" +
                            '"' +
                            document.querySelector<HTMLLIElement>(".tag.tag-selected")?.dataset.tagName +
                            '"' +
                            "</strong>  zugewiesen hast." +
                            "<br>" +
                            "<br>" +
                            "Neben allen Einträgen gehen dabei auch alle Bewertungen und Notizen endgültig verloren. Das Tag selber bleibt erhalten." +
                            "<br>" +
                            "<br>" +
                            "Diese Aktion kann nicht rückgängig gemacht werden. Bist du dir sicher?"
                    }

                    if (confirmEntriesDeletionModalTitle) {
                        confirmEntriesDeletionModalTitle.innerHTML = "Merkzettel - Einträge mit Tag entfernen"
                    }
                }

                if (confirmEntriesDeletionModalConfirmButton) {
                    confirmEntriesDeletionModalConfirmButton.addEventListener("click", async () => {
                        const success = await deleteAllBookmarks(tagSlug)

                        if (success) {
                            $(confirmEntriesDeletionModal).modal("hide")
                            updateMerkzettelStateInMenu(true)
                            if (tagSlug === "") {
                                removeAllBookmarksFromDom()
                                hideSideBarOptions()
                                hideInfoContainer()
                                showEmptyBookmarksInfoBox()
                            } else {
                                hideSideBarOptions()
                                removeVisibleEntriesFromDom()
                                showEmptyTagHitsContainer()
                            }
                        } else {
                            InfoPanel.displayMessage(
                                "Beim Löschen aller Anzeigen ist ein Fehler aufgetreten. Bitte versuche es erneut.",
                                InfoPanel.Type.Error,
                                2 * 1000, // expects Milliseconds
                            )
                        }
                    })
                }
                $(confirmEntriesDeletionModal).modal("show")
            }
        })
    }

    if (cleanOfflineBookmarksButtonElement) {
        cleanOfflineBookmarksButtonElement.addEventListener("click", async () => {
            const success = await clearOfflineBookmarks()
            if (success) {
                updateMerkzettelStateInMenu(true)
                removeAllOfflineBookmarksFromDom()
                showEmptyBookmarksInfoBoxWhenNoEntries()

                InfoPanel.displayMessage(
                    "Alle nicht mehr verfügbaren Anzeigen wurden erfolgreich aus dem Merkzettel entfernt.",
                    InfoPanel.Type.Success,
                    2 * 1000, // expects Milliseconds
                )
            } else {
                InfoPanel.displayMessage(
                    "Beim Entfernen der nicht mehr verfügbaren Anzeigen ist ein Fehler aufgetreten. Bitte versuche es erneut.",
                    InfoPanel.Type.Error,
                    2 * 1000, // expects Milliseconds
                )
            }
        })
    }

    if (shareAllButtonElement && shareModal) {
        shareAllButtonElement.addEventListener("click", async () => {
            const shareModalDescription = document.querySelector(
                "#share-modal-description",
            ) as HTMLParagraphElement | null
            const selectedTag = document.querySelector(".tag.tag-selected") as HTMLLIElement | null
            const tagSlug = selectedTag?.getAttribute("data-tag-slug") ?? ""
            const tagSlugName = selectedTag?.getAttribute("data-tag-name") ?? ""

            if (userData.isLoggedIn && shareModalDescription) {
                if (tagSlugName !== "") {
                    shareModalDescription.innerHTML = `Teile deine Favoriten mit deinen Freunden, im Ladies-Forum oder im Web. Es werden nur die Einträge mit dieser Favoritenliste geteilt, denen du das Tag "<span class="text-bold">${tagSlugName}</span>" zugewiesen hast.`
                }

                if (tagSlug === "" && tagSlugName === "" && selectedTag !== null) {
                    shareModalDescription.innerHTML = `Teile deine Favoriten mit deinen Freunden, im Ladies-Forum oder im Web. Es werden nur die Einträge mit dieser Favoritenliste geteilt, die "<span class="text-bold">ohne Tag</span>" sind.`
                }

                if (selectedTag === null) {
                    shareModalDescription.innerHTML =
                        "Es werden <strong>alle</strong> Einträge deines Merkzettels mit dieser Favoritenliste geteilt. Wähle ein Tag aus, um nur die Einträge zu teilen, denen es zugewiesen ist."
                }
            }

            await shareAllBookmarks(tagSlug)
                .then((response: ShareKeyResponse) => {
                    const modalLinkButton = queryElement(".merkzettel-link", shareModal) as HTMLInputElement
                    const modalValidToDate = queryElement(".valid-to-date") as HTMLSpanElement
                    const modalValidToTime = queryElement(".valid-to-time") as HTMLSpanElement
                    const modalShareQrCode = queryElement("#shared-merkzettel-code", shareModal) as HTMLImageElement

                    const d = new Date()
                    d.setMonth(d.getMonth() + 1)

                    const result = `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`
                    const time = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`

                    const favLink = window.location.href.replace("/merkzettel", "/fav") + `/${response.shareKey}`

                    modalLinkButton.value = favLink
                    modalValidToDate.innerHTML = result
                    modalValidToTime.innerHTML = time

                    if (modalShareQrCode.children.length === 0) {
                        new QRCode(modalShareQrCode, {
                            link: favLink,
                            height: 110,
                            width: 110,
                        }).makeCode(favLink)
                    }

                    const shareModalMailButton = queryElement(
                        ".social.mail.share-merkzettel",
                        shareModal,
                    ) as HTMLButtonElement | null
                    const shareModalWhatsAppButton = queryElement(
                        ".social.whatsapp.share-merkzettel",
                        shareModal,
                    ) as HTMLButtonElement | null
                    const shareModalFacebookButton = queryElement(
                        ".social.facebook.share-merkzettel",
                        shareModal,
                    ) as HTMLButtonElement | null
                    const shareModalTwitterButton = queryElement(
                        ".social.twitter.share-merkzettel",
                        shareModal,
                    ) as HTMLButtonElement | null
                    const encodedFavLink = encodeURI("fav" + `/${response.shareKey}`)

                    if (shareModalMailButton) {
                        const mailHref = shareModalMailButton.getAttribute("href") ?? ""
                        shareModalMailButton.setAttribute("href", mailHref.replace("merkzettel", encodedFavLink))
                    }

                    if (shareModalWhatsAppButton) {
                        const whatsappHref = shareModalWhatsAppButton.getAttribute("href") ?? ""
                        shareModalWhatsAppButton.setAttribute(
                            "href",
                            whatsappHref.replace("merkzettel", encodedFavLink),
                        )
                    }

                    if (shareModalFacebookButton) {
                        const facebookHref = shareModalFacebookButton.getAttribute("href") ?? ""
                        shareModalFacebookButton.setAttribute(
                            "href",
                            facebookHref.replace("merkzettel", encodedFavLink),
                        )
                    }
                    if (shareModalTwitterButton) {
                        const twitterHref = shareModalTwitterButton.getAttribute("href") ?? ""
                        shareModalTwitterButton.setAttribute("href", twitterHref.replace("merkzettel", encodedFavLink))
                    }

                    $(shareModal).modal("show")
                })
                .catch((error: Error) => {
                    InfoPanel.displayMessage(
                        "Beim Teilen aller Anzeigen ist ein Fehler aufgetreten. Bitte versuche es erneut. ",
                        InfoPanel.Type.Error,
                        2 * 1000, // expects Milliseconds
                    )
                    throw error
                })
        })
    }

    if (collapseExpandButtonElement) {
        collapseExpandButtonElement.addEventListener("click", () => {
            const entryCards = document.querySelectorAll(".entry-card")
            const recalculateContactBoxHeight = (moreButton: HTMLElement): void => {
                const contactBox = moreButton
                    .closest("article")
                    ?.querySelector<HTMLElement>(".entry-card--contact-box") as HTMLElement | null
                const contentHeightPx: number = contactBox?.querySelector("div")?.scrollHeight ?? 0

                contactBox?.style.setProperty("--open-container-height", contentHeightPx + "px")
            }

            const textNode = collapseExpandButtonElement.lastChild
            const expandText = "Infos einklappen"
            const collapseText = "Infos ausklappen"

            if (textNode && textNode.nodeType === Node.TEXT_NODE) {
                textNode.textContent = textNode.textContent?.trim() === collapseText ? expandText : collapseText
            }

            const useEl = collapseExpandButtonElement.querySelector("use")
            if (useEl) {
                useEl.setAttribute(
                    "href",
                    textNode?.textContent === collapseText ? "#down-arrow-icon" : "#up-arrow-icon",
                )
            }

            for (const card of entryCards) {
                const entryCollapseIconButton = card.querySelector(".entry-more-data")
                const contactBox = card.querySelector(".entry-card--contact-box") as HTMLElement | null

                if (entryCollapseIconButton) {
                    textNode?.textContent === expandText
                        ? entryCollapseIconButton.classList.add("active")
                        : entryCollapseIconButton.classList.remove("active")
                    const moreLabel = entryCollapseIconButton.querySelector("#more-label")

                    if (moreLabel) {
                        moreLabel.textContent = textNode?.textContent === expandText ? "weniger" : "mehr"
                    }
                }

                if (contactBox) {
                    textNode?.textContent === collapseText
                        ? contactBox.classList.remove("open")
                        : contactBox.classList.add("open")
                    recalculateContactBoxHeight(contactBox)
                }
            }

            const collapseIcon = collapseExpandButtonElement.querySelector(".collapse-icon") as HTMLElement | null
            const expandIcon = collapseExpandButtonElement.querySelector(".expand-icon") as HTMLElement | null

            if (collapseIcon && expandIcon) {
                const isCollapsed = textNode?.textContent === expandText
                collapseIcon.style.display = isCollapsed ? "none" : "block"
                expandIcon.style.display = isCollapsed ? "block" : "none"
            }
        })
    }
}

function showEmptyBookmarksInfoBox() {
    const infoBox = document.querySelector(".empty-bookmarks-info-box")
    if (infoBox) {
        infoBox.classList.remove("hide")
    }
}

export function showEmptyBookmarksInfoBoxWhenNoEntries() {
    const entryList = document.getElementById("entry-list")
    if (entryList && entryList.children.length === 0) {
        showEmptyBookmarksInfoBox()
        hideSideBarOptions()
        hideInfoContainer()
    }
}

function removeAllBookmarksFromDom() {
    const entryList = document.getElementById("entry-list")
    if (entryList) {
        const bookmarks = entryList ?? null

        if (bookmarks) {
            bookmarks.replaceChildren()
        }
    }
}

function removeVisibleEntriesFromDom() {
    const entryList = document.getElementById("entry-list")
    if (entryList) {
        const hasVisibleCards = document.querySelectorAll(".entry-card:not(.hidden)")

        for (let i = hasVisibleCards.length - 1; i >= 0; i--) {
            hasVisibleCards[i].remove()
        }
    }
}

function removeAllOfflineBookmarksFromDom() {
    const entryList = document.getElementById("entry-list")
    if (entryList) {
        const items = entryList.querySelectorAll('li[data-is-online="false"]')

        for (let i = items.length - 1; i >= 0; i--) {
            items[i].remove()
        }
    }
}

export function hideSideBarOptions() {
    const container = document.querySelector(".bookmarks-container")
    const sideBarOptionsElement = document.querySelector(".options") || null

    if (sideBarOptionsElement) {
        sideBarOptionsElement.classList.add("hidden")
        container?.classList.toggle("no-options", true)
    }
}

export function showSideBarOptions() {
    const container = document.querySelector(".bookmarks-container")
    const sideBarOptionsElement = document.querySelector(".options") || null

    if (sideBarOptionsElement) {
        sideBarOptionsElement.classList.remove("hidden")
        container?.classList.toggle("no-options", false)
    }
}

function hideInfoContainer() {
    const infoContainer = document.getElementById("session-bookmarks-info")

    if (infoContainer) {
        infoContainer.classList.add("hide")
    }
}

async function shareAllBookmarks(tagSlug: null | string): Promise<ShareKeyResponse> {
    let api = userData.userId === 0 ? "/api/bookmarks/share" : `/api/bookmarks/${userData.userId}/share`

    if (tagSlug !== null && userData.userId !== 0 && tagSlug !== "") {
        api += `/${tagSlug}`
    }

    const response = await fetch(api, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    })

    if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`)
    }

    return response.json()
}

async function clearOfflineBookmarks(): Promise<boolean> {
    const api = userData.userId === 0 ? "/api/bookmarks/clean" : `/api/bookmarks/${userData.userId}/clean`

    try {
        const response = await fetch(api, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                confirm: true,
            }),
        })

        return response.ok
    } catch (error) {
        return false
    }
}

async function deleteAllBookmarks(tagSlug: string): Promise<boolean> {
    const api = userData.userId === 0 ? "/api/bookmarks/clear-all" : `/api/bookmarks/${userData.userId}/clear-all`

    try {
        const response = await fetch(api, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                confirm: true,
                tagSlug: tagSlug,
            }),
        })

        return response.ok
    } catch (error) {
        return false
    }
}
